import React  from "react";
import { Text, View,  TouchableOpacity,  Image} from "react-native";
import { CreateResponsiveStyle,DEVICE_SIZES,maxSize} from "rn-responsive-styles";

export default function ModalAlert(props) {
  const styles = useStyles();
  const success = "success";
  const error = "error";
  const pending = "pending";
  const request_initiated = "request_initiated";

  const onPressActionButton = () => {
    if (props.navigateScreen != "") {
      props.onCloseModal(props.navigateScreen);
    } else {
      props.onCloseModal();
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.overlay}>
        <View style={styles.loaderBg}>
          <Text style={[styles.title]}>{props.title}</Text>
          {props.status === success ? (
            <Image
              source={require("../assets/images/Success.png")}
              style={styles.iconSuccess}
            />
          ) : props.status === pending ? (  <Image
            source={require("../assets/images/pending.png")}
            style={styles.iconSuccess}
          />
          ) : props.status === request_initiated ? (
            <Image
              source={require("../assets/images/request_initiated.png")}
              style={styles.iconSuccess}
            />
          ) : (
            <Image
              source={require("../assets/images/error.png")}
              style={styles.iconError}
            />
          )}
            <Text style={styles.text}>{props.message}</Text>
          {props.actionButton != "" && (
            <View style={styles.footer}>
              <TouchableOpacity onPress={() => onPressActionButton()} style={styles.footerBtn} >
                <Text style={styles.footerLink}> {props.actionButton}</Text>
              </TouchableOpacity>
            </View>
          )}
        </View>
      </View>
    </View>
  );
}

const useStyles = CreateResponsiveStyle({
  container: {
     position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 99999, 
  },
  overlay: {
   width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  loaderBg: {
    backgroundColor: "white",
    width: 350,
    height: 270,
    borderRadius: 20,
    justifyContent: "flex-start",
    alignItems: "center",
    shadowColor: "rgba(0,0,0,0.05)",
    shadowOpacity: 1.5,
    elevation: 12,
    shadowRadius: 20,
    shadowOffset: { width: 1, height: 13 },
  },
  iconSuccess: {
    marginVertical: 15,
    width: 38,
    height: 38,
  },
  iconError: {
    marginVertical: 15,
    width: 45,
    height: 42,
  },
  title: {
    color: "#5a5755",
    fontFamily: "Inter",
    fontSize: 18,
    alignSelf: "center",
    marginTop: 25,
  },
  text: {
    color: "#02122c",
    fontFamily: "Inter",
    fontSize: 13,
    opacity: 0.8,
    alignSelf: "center",
    marginBottom: 10,
    textAlign:"center",
    paddingHorizontal:15
  },
  footer: {
    width: "100%",
    bottom: 0,
    paddingVertical: 10,
    alignItems: "center",
  },
  footerBtn: {
    width: "auto",
    height: 30.5,
    borderRadius: 16,
    borderColor: "#d6d6d6",
    borderWidth: 1,
    paddingVertical: 5,
    paddingHorizontal: 20,
    alignItems: "center",
  },
  footerLink: {
    fontFamily: "Inter",
    fontSize: 11,
    fontWeight: "bold",
    fontStyle: "normal",
    letterSpacing: -0.22,
    textAlign: "left",
    color: "#9d1d27",
    alignSelf:"center",
    paddingTop:2
  },
},
{
  [maxSize(DEVICE_SIZES.XS)]: {
    loaderBg: {
      backgroundColor: "white",
      width: "90%",
      height: 290,
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
     overlay: {
    width: "100%",
    height: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop:"30%"
  },
  },
});
